import { StoreModel, UserModel } from 'src/mst/models';

export const getUserModel = (store: StoreModel): UserModel => {
  return store.user;
};
